function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export var makePatchSponsorDTO = function(args) {
    return {
        data: _object_spread_props(_object_spread({}, !args.isMepTpa && {
            isPartOfControlGroup: args.values.isPartOfControlGroup
        }), {
            dayToDayContactLastName: args.values.dayToDayContactLastName,
            hasOtherBusinesses: args.values.isPartOfControlGroup,
            physicalAddress: {
                address1: args.values.physicalAddress1,
                address2: args.values.physicalAddress2,
                city: args.values.physicalCity,
                state: args.values.physicalState,
                zip: args.values.physicalZip
            }
        })
    };
};
export var makePatchQuestionnaireDTO = function(args) {
    var _args_values_currentComplianceIssues;
    var _args_values_currentComplianceIssues_map;
    return {
        data: {
            attributes: {
                onboarding: _object_spread_props(_object_spread({
                    authSignerFirstName: args.values.authSignerFirstName,
                    authSignerLastName: args.values.authSignerLastName,
                    authSignerWorkPhone: args.values.authSignerWorkPhone,
                    authorizedSignerEmail: args.values.authorizedSignerEmail
                }, !args.isMepTpa && {
                    anticipatedHires: args.values.anticipatedHires,
                    contributionScenario: args.values.contributionScenario,
                    currentComplianceIssues: (_args_values_currentComplianceIssues_map = (_args_values_currentComplianceIssues = args.values.currentComplianceIssues) === null || _args_values_currentComplianceIssues === void 0 ? void 0 : _args_values_currentComplianceIssues.map(function(v) {
                        return v.value;
                    })) !== null && _args_values_currentComplianceIssues_map !== void 0 ? _args_values_currentComplianceIssues_map : [],
                    existingPlanProvider: args.values.existingPlanProvider,
                    existingPlanType: args.values.existingPlanType,
                    highlyCompensatedEmployees: args.values.highlyCompensatedEmployees,
                    industryGroup: args.values.industryGroup,
                    isConvertedPlan: args.values.isConvert,
                    ownerEmployees: args.values.ownerEmployees,
                    payrollProviderId: args.values.payrollProviderId,
                    payrollProviderOther: args.values.payrollSystemOther,
                    relativesOfOwnerEmployees: args.values.relativesOfOwnerEmployees,
                    retirementObjectives: args.values.retirementObjectives,
                    totalEmployeesNumber: args.values.totalEmployeesNumber
                }), {
                    questionnaireSubmittedAt: _instanceof(args.questionnaireSubmittedAt, Date) ? args.questionnaireSubmittedAt.toISOString() : null
                }),
                plan: {
                    planName: args.planName
                },
                sponsor: _object_spread({
                    companyEntityType: args.values.companyEntityType,
                    companyName: args.values.companyName,
                    companyPhoneNumber: args.values.companyPhoneNumber,
                    dayToDayContactEmail: args.values.dayToDayContactEmail,
                    dayToDayContactName: args.values.dayToDayContactName,
                    dayToDayContactNumber: args.values.dayToDayContactNumber,
                    doingBusinessAs: args.values.doingBusinessAs,
                    employerIdentificationNumber: args.values.employerIdentificationNumber,
                    fiscalYearEnd: args.values.fiscalYearEnd,
                    isConvert: args.values.isConvert,
                    stateOfIncorporation: args.values.stateOfIncorporation,
                    wiredAtWork: args.values.wiredAtWork
                }, !args.isMepTpa && {
                    controlGroupBusinesses: JSON.stringify(args.values.controlGroupBusinesses)
                })
            }
        }
    };
};

//# sourceMappingURL=convertQuestionnaireUIToApi.js.map